import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_SCAFFOLDS,
  LINK_SCAFFOLD_JOBS,
  UPDATE_SCAFFOLD,
} from '../../../graph-queries/tar/scaffold';
import { TScaffold } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import ScaffoldForm from '../ScaffoldForm/ScaffoldForm';
import { columns } from '../../pages/Scaffolds/Scaffolds';
import classes from './JobAspects.module.scss';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobScaffolds: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_SCAFFOLDS, {
    variables: { jobId },
  });
  const [updateScaffold] = useMutation(UPDATE_SCAFFOLD, {
    refetchQueries: [GET_JOB_SCAFFOLDS],
  });
  const [linkScaffoldJobs] = useMutation(LINK_SCAFFOLD_JOBS, {
    refetchQueries: [GET_JOB_SCAFFOLDS],
  });

  const onEditSubmit = (scaffold: TScaffold) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = scaffold;
    return updateScaffold({ variables: { input } });
  };

  const onLinkSubmit = (selection: TScaffold[], jobIds: number[]) => {
    return Promise.all(
      selection.map((scaffold) =>
        linkScaffoldJobs({
          variables: {
            scaffoldId: scaffold.scaffoldId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TScaffold>
      aspectName="scaffold"
      data={(data?.scaffoldsByJobId as unknown as TScaffold[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <ScaffoldForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Scaffolds</div>}
    />
  );
};

export default JobScaffolds;
